import { render, staticRenderFns } from "./viewAllExpenseDetails.vue?vue&type=template&id=f96aa83a&"
import script from "./viewAllExpenseDetails.vue?vue&type=script&lang=js&"
export * from "./viewAllExpenseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports